import styled from 'styled-components'
import devices from '../../styles/device'

export const Container = styled.div`
  max-width: 80vw;
  font-size: 2.5rem;
`

export const Gallery = styled.div`
  column-count: 4;
  column-gap: 1rem;
  @media ${devices.tablet} {
    column-count: 3;
  }
  @media ${devices.mobile} {
    column-count: 2;
  }
`

export const ImageContainer = styled.div`
  display: inline-block;
  margin: 0 0 1rem;
  width: 100%;
`
